import * as React from 'react';

import useAuthStore from 'store/authStore/useAuthStore';

import { Bar } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import { Container, Divider, Label, Row, Title } from './Sidebar.styled';
import {
    Container as Progress,
    Header,
    Pillar,
} from './VotesProgressLine/VotesProgressLine.styled';

const SidebarLoading = ({ title }: { title?: string }) => {
    const { isLogged } = useAuthStore();
    return (
        <Container aria-hidden="true">
            <Title>{title ?? <Bar $width="20rem" $height="2.8rem" />}</Title>
            {['Users voted', ...(isLogged ? ['Your vote'] : []), 'Votes', '% of votes'].map(
                label => (
                    <Row key={label}>
                        <Label>{label}</Label>
                        <Bar $width="9rem" $height="2.4rem" />
                    </Row>
                ),
            )}
            <Divider />
            <Progress>
                <Header>
                    <Label>Upvotes</Label>
                    <Bar $width="9rem" $height="2.4rem" />
                </Header>
                <Pillar />
            </Progress>
            {['ICE voted:', 'dICE voted:'].map(label => (
                <Row key={label}>
                    <Label>{label}</Label>
                    <Bar $width="9rem" $height="2rem" />
                </Row>
            ))}
            <Bar $width="100%" $height="4.8rem" />
        </Container>
    );
};

export default SidebarLoading;
